module.exports = __webpack_public_path__ + "static/media/img2.9191df5e.jpg";